// @ts-nocheck
import * as Types from '../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UseLocationsTreeQueryVariables = Types.Exact<{
  rpavId: Types.Scalars['ID']['input'];
}>;


export type UseLocationsTreeQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: string, name: string, parents: Array<{ __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', name: string, code: Types.LocationType } }>, type: { __typename?: 'LocationTypeDetail', name: string, code: Types.LocationType } }> };

export type UseLocationsTree_LocationFragment = { __typename?: 'Location', id: string, name: string, parents: Array<{ __typename?: 'Location', id: string, name: string, type: { __typename?: 'LocationTypeDetail', name: string, code: Types.LocationType } }>, type: { __typename?: 'LocationTypeDetail', name: string, code: Types.LocationType } };

export const UseLocationsTree_LocationFragmentDoc = gql`
    fragment UseLocationsTree_Location on Location {
  ...Named
  parents {
    id
    name
    type {
      name
      code
    }
  }
  type {
    name
    code
  }
}
    ${NamedFragmentDoc}`;
export const UseLocationsTreeDocument = gql`
    query UseLocationsTree($rpavId: ID!) {
  locations(filter: {rpav: [$rpavId], scope: false, version: [2]}) {
    ...UseLocationsTree_Location
  }
}
    ${UseLocationsTree_LocationFragmentDoc}`;

/**
 * __useUseLocationsTreeQuery__
 *
 * To run a query within a React component, call `useUseLocationsTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUseLocationsTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUseLocationsTreeQuery({
 *   variables: {
 *      rpavId: // value for 'rpavId'
 *   },
 * });
 */
export function useUseLocationsTreeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UseLocationsTreeQuery, UseLocationsTreeQueryVariables> & ({ variables: UseLocationsTreeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UseLocationsTreeQuery, UseLocationsTreeQueryVariables>(UseLocationsTreeDocument, options);
      }
export function useUseLocationsTreeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UseLocationsTreeQuery, UseLocationsTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UseLocationsTreeQuery, UseLocationsTreeQueryVariables>(UseLocationsTreeDocument, options);
        }
// @ts-ignore
export function useUseLocationsTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UseLocationsTreeQuery, UseLocationsTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UseLocationsTreeQuery, UseLocationsTreeQueryVariables>;
export function useUseLocationsTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UseLocationsTreeQuery, UseLocationsTreeQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UseLocationsTreeQuery | undefined, UseLocationsTreeQueryVariables>;
export function useUseLocationsTreeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UseLocationsTreeQuery, UseLocationsTreeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UseLocationsTreeQuery, UseLocationsTreeQueryVariables>(UseLocationsTreeDocument, options);
        }
export type UseLocationsTreeQueryHookResult = ReturnType<typeof useUseLocationsTreeQuery>;
export type UseLocationsTreeLazyQueryHookResult = ReturnType<typeof useUseLocationsTreeLazyQuery>;
export type UseLocationsTreeSuspenseQueryHookResult = ReturnType<typeof useUseLocationsTreeSuspenseQuery>;
export type UseLocationsTreeQueryResult = ApolloReactCommon.QueryResult<UseLocationsTreeQuery, UseLocationsTreeQueryVariables>;